import { useMemo } from "react";
import dayjs from "dayjs";

import ILampiran from "assets/lampiran.png";

const roundAmount = (amount) => {
  if (!amount) return "";

  let temp = amount;

  if (typeof amount !== "number") temp = parseInt(amount);

  return Math.round(temp).toLocaleString("id-ID");
};

const handleDate = (date) => dayjs(date).format("DD/MM/YYYY; HH:mm");

const Lampiran = ({ data }) => {
  const LAMPIRAN = useMemo(() => {
    const payee = data?.management_fee_invoice;

    const dataMutasi = payee?.transaction_reports?.map((trx) => {
      const trxDetail = trx?.transaction_details?.[0];
      const trxLocation = trxDetail?.property_location;
      const hasTrxLocation = trxLocation && Object.keys(trxLocation).length > 0;
      const lokasi = hasTrxLocation
        ? trxDetail?.property_location?.area +
          ", " +
          trxDetail?.property_location?.city +
          ", " +
          trxDetail?.property_location?.province
        : "Dari kantor lain";

      return {
        idUser: trx?.user_id,
        idTransaction: trx?.id,
        tanggal: handleDate(trx?.created_at),
        namaMarketing: trx?.marketings?.map(
          (marketing) => marketing?.full_name,
        ),
        nilaiTransaksi: `Rp ${roundAmount(trxDetail?.trx_amount)}`,
        gcc: `Rp ${roundAmount(trx?.gcc_amount)}`,
        namaListing: trxDetail?.property_title,
        lokasi,
        inputDate: handleDate(trx?.created_at),
        approvedDate: handleDate(trx?.approved_at),
        propertyType: trxDetail?.property_type ?? "Co-Broking Antar Kantor",
      };
    });

    let result = {
      jumlahTransaksi: dataMutasi?.length || 0,
      dataMutasi: dataMutasi,
      jumlahMarketing: payee?.gcc_details?.length || 0,
    };

    return result;
  }, [data]);

  return (
    <div>
      <div className="px-6 pb-2 mb-2 flex items-center gap-2 border-b border-solid border-[#D8D8D9]">
        <img
          className="w-6 h-6 object-contain"
          src={ILampiran}
          alt="lampiran"
        />
        <p className="text-[22px] leading-[35.596px] tracking-[-0.4px] font-semibold text-[#252526]">
          Lampiran
        </p>
      </div>
      <p className="mb-2 px-6 text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
        Jumlah Transaksi:{" "}
        <span className="text-[#252526]">{LAMPIRAN?.jumlahTransaksi}</span>
      </p>

      <div className="px-6">
        <div className="grid grid-cols-[80px_1fr_1fr_1fr_1fr] px-4 py-2 bg-[#F5F5F5]">
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
            ID Transaksi
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
            Tanggal
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
            Nama Marketing
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285] text-end">
            Nilai Transaksi
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285] text-end">
            GCC
          </p>
        </div>
        {!!LAMPIRAN?.dataMutasi?.length &&
          LAMPIRAN?.dataMutasi?.map((item, index) => (
            <div
              key={index}
              className="px-4 py-2 border-b-[0.5px] border-solid border-[#D8D8D9] last:border-none"
            >
              <div className="py-2 grid grid-cols-[80px_1fr_1fr_1fr_1fr]">
                <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
                  {item.idTransaction}
                </p>
                <div>
                  <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
                    Input:{" "}
                    <span className="text-[#252526]">{item.inputDate}</span>
                  </p>
                  <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
                    Approved:{" "}
                    <span className="text-[#252526]">{item.approvedDate}</span>
                  </p>
                </div>
                <div className="">
                  {item.namaMarketing?.map((item, idx) => (
                    <p
                      className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526] truncate"
                      key={index + "_" + idx}
                    >
                      {item}
                    </p>
                  ))}
                </div>
                <p className="flex flex-col items-end text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526] text-end">
                  <p className="text-[13px] mb-1 leading-[21.034px] tracking-[-0.4px] text-[#808285]">
                    {item.nilaiTransaksi}
                  </p>
                  <p
                    className={
                      "w-fit text-[11px] leading-[17.798px] tracking-[-0.4px] h-4 px-2 rounded-[80px] border-[0.5px] border-solid flex items-center justify-center" +
                      (item.propertyType === "Jual"
                        ? "bg-[#EBF0F7] border-[#3268AE] text-[#3268AE]"
                        : "bg-[#F6E5B6] border-[#AC7E02] text-[#AC7E02]")
                    }
                  >
                    {item.propertyType}
                  </p>
                </p>
                <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526] text-end">
                  {item.gcc}
                </p>
              </div>
              <div className="px-1 py-2 bg-[#FAFAFA]">
                <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
                  Nama listing:{" "}
                  <span className="text-[#252526]">{item.namaListing}</span>
                </p>
                <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
                  Lokasi properti:{" "}
                  <span className="text-[#252526]">{item.lokasi}</span>
                </p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default Lampiran;
